"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockRetailAuthModule = void 0;
const inversify_1 = require("inversify");
const RetailSession_1 = require("../../models/RetailSession");
const AuthModule_1 = require("../../../../../apis/spg/client/modules/AuthModule");
const mockRetailCustomers_1 = require("./data/mockRetailCustomers");
const guid_1 = require("../../../../../apis/spg/util/guid");
const mockRetailLocations_1 = require("./data/mockRetailLocations");
const currentUnixTimestamp_1 = require("../../../../../apis/spg/util/currentUnixTimestamp");
let MockRetailAuthModule = class MockRetailAuthModule extends AuthModule_1.AuthModule {
    constructor(_httpConnection, _webSocketConnection, _syncModule, GenericSessionCls, GenericLocationCls) {
        super(_httpConnection, _webSocketConnection, _syncModule, GenericSessionCls, GenericLocationCls);
        this._httpConnection = _httpConnection;
        this._webSocketConnection = _webSocketConnection;
        this._syncModule = _syncModule;
        this.GenericSessionCls = GenericSessionCls;
        this.GenericLocationCls = GenericLocationCls;
        this.createRetailSession = (sessionId) => {
            const retailCustomer = mockRetailCustomers_1.mockSerializedRetailCustomers[0];
            const sId = sessionId || (0, guid_1.createGuid)();
            const session = {
                // id: sId, // TODO: (legacy) - deprecate once everything has been updated
                sessionId: sId,
                availableLocations: mockRetailLocations_1.mockSerializedRetailLocations,
                retailCustomerId: retailCustomer.retailCustomerId,
                retailCustomer,
                createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
                expiresAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)() + 1000000,
                permissions: []
            };
            const sessionModel = RetailSession_1.RetailSession.unserialize(session);
            this.setSession(sessionModel);
            return sessionModel;
        };
    }
    setSession(newSession) {
        super.setSession(newSession);
    }
    async loginAsCustomer(email, password) {
        return this.createRetailSession();
    }
    async setSessionFromSessionId(sessionId) {
        return this.createRetailSession(sessionId);
    }
    async logout() {
        // emit "beforeLogout" event for any listeners
        this.emit("beforeLogout");
        // reset session
        this.setSession(null);
        // reset sessionTemporaryAccess if true
        if (this._sessionTemporaryAccessGranted === true) {
            this.revokeSessionTemporaryAccess();
        }
    }
};
MockRetailAuthModule = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)("HttpConnection")),
    __param(1, (0, inversify_1.inject)("WebSocketConnection")),
    __param(2, (0, inversify_1.inject)("SyncModule")),
    __param(3, (0, inversify_1.inject)("interfaces.Newable<RetailSession>")),
    __param(4, (0, inversify_1.inject)("interfaces.Newable<RetailLocation>"))
], MockRetailAuthModule);
exports.MockRetailAuthModule = MockRetailAuthModule;
//# sourceMappingURL=MockRetailAuthModule.js.map